import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { GeneralService } from '../../services/general.service';
import { FormularioService } from '../../services/formulario.service';
import { MockDTO } from './mock/mock-formule';
import { NotificationService } from '../../services/notification.service';
import { CabecalhoDTO } from '../../entity/dto/cabecalho.component';
import { Router } from '@angular/router';
import { FormuleConfigService } from './service/formule-config.service';
import { FormuleConfig } from './model/FormuleConfig';
import { MatDialog } from '@angular/material/dialog';
import { SimpleModalComponent } from '../../shared/simple-modal/simple-modal.component';
import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-formule-config',
  templateUrl: './formule-config.component.html',
  styleUrls: ['./formule-config.component.scss'],
})
export class FormuleConfigComponent implements OnInit, AfterViewInit {  
  displayedColumns?: string[] = ['created_at', 'name', 'description' ,'status', '#'];
  dataSource?: MatTableDataSource<any>;
  pageSizeOptions?: number[] = [];
  header?: CabecalhoDTO;
  statusClient = JSON.parse(localStorage.getItem('statusNetwork'));
  formFilter: FormGroup;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private formularioService: FormularioService,
    private generalService: GeneralService,
    private notificationService: NotificationService,
    private router: Router,
    private service: FormuleConfigService,
    private dialog: MatDialog,
    private _fb: FormBuilder
  ) {}

  async ngAfterViewInit(): Promise<void> {
    return await this.getData();
  }

  ngOnInit(): void {
    this.createForm();
    this.pageSizeOptions = this.formularioService.pageSizeOptions;
  }

  createForm = () => {
    this.formFilter = this._fb.group({
      search: [null]
    });
  }

  configDataTable(lista: Array<any>): void {
    this.dataSource = new MatTableDataSource(lista);
    this.dataSource.paginator = this.paginator;
    this.dataSource.paginator._intl.firstPageLabel =
      this.formularioService.firstPageLabel;
    this.dataSource.paginator._intl.lastPageLabel =
      this.formularioService.lastPageLabel;
    this.dataSource.paginator._intl.itemsPerPageLabel =
      this.formularioService.itemsPerPageLabel;
    this.dataSource.paginator._intl.nextPageLabel =
      this.formularioService.nextPageLabel;
    this.dataSource.paginator._intl.previousPageLabel =
      this.formularioService.previousPageLabel;
    this.paginator._intl.getRangeLabel = (
      page: number,
      pageSize: number,
      length: number
    ) => {
      if (length === 0 || pageSize === 0) {
        return `0 de ${length}`;
      }
      length = Math.max(length, 0);
      const startIndex = page * pageSize;
      const endIndex =
        startIndex < length
          ? Math.min(startIndex + pageSize, length)
          : startIndex + pageSize;
      return `${startIndex + 1} – ${endIndex} de ${length}`;
    };
    this.dataSource.sort = this.sort;
  }

  getData = async () => {
    const status = await this.generalService.getConnectionStatus();
    const data_offline = await this.generalService.getDataFromLocalStorage(
      'formule-config'
    );
    if (status) {
      if (data_offline?.length > 0) {
        await this.getList(data_offline);
      } else {
        await this.getList();
      }
    } else {
      await this.configDataTable(data_offline);
    }
  };

  getList = async (dataOff: any[] = []) => {
    await this.service
      .getList(this.formFilter.controls.search.value)
      .then((node) => {
        if (dataOff.length > 0) {
          node = dataOff.concat(node);
        }
        this.configDataTable(node);
      })
      .catch((err) => console.error(err));
  };

  goToStatus(item: FormuleConfig) {
    let input = {
      title: item.active ? 'Desativar' : 'Ativar',
      titleBtn1: 'Não',
      titleBtn2: 'Sim',
      mensage: '',
    };

    if (item.active) {
      input.mensage = 'Deseja realmente desativar essa Fórmula?';
    } else {
      input.mensage = 'Deseja realmente ativar essa Fórmula?';
    }

    const dialogRef = this.dialog.open(SimpleModalComponent, {
      width: '600px',
      data: input,
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        item.active = !item.active;
        await this.activeOrDisable(item);
      }
    });
  }

  goToSave = async () => {
    const status =
      localStorage.getItem('statusNetwork') === 'true' ? 'false' : 'true';
    this.router.navigateByUrl('/formule-config/new/' + status);
  };

  goToEdit = (item: FormuleConfig) => {
    let idOrName = item.isOff ? item.name : item.id;
    this.router.navigateByUrl(
      '/formule-config/update/' + idOrName + '/' + item.isOff
    );
  };

  goToDelete = (item: FormuleConfig) => {
    const dialogRef = this.dialog.open(SimpleModalComponent, {
      data: {
        title: 'Excluir',
        mensage: 'Deseja realmente excluir essa Fórmula?',
        titleBtn1: 'Não',
        titleBtn2: 'Sim',
      },
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        if (item.isOff === undefined) {
          await this.deleteFormuleConfig(item.id);
        } else {
          this.deleteItemOff(item);
        }
      }
    });
  };

  deleteItemOff = async (item: FormuleConfig) => {
    const data_offline = await this.generalService.getDataFromLocalStorage(
      'formule-config'
    );
    let listOff: FormuleConfig[] = data_offline.filter(
      (a) => a.name !== item.name
    );
    localStorage.setItem('data_formule-config', JSON.stringify(listOff));
    this.notificationService.sendNotification(
      null,
      TypeMessage.Delete,
      ActionMessage.Success
    );
    this.getData();
  };

  deleteFormuleConfig = async (id: number) => {
    await this.service
      .delete(id)
      .then((node) => {
        this.notificationService.sendNotification(
          null,
          TypeMessage.Delete,
          ActionMessage.Success
        );
        this.getData();
      })
      .catch((err) => console.error(err));
  };

  activeOrDisable = async (item: FormuleConfig) => {
    if (item.isOff === undefined) {
      await this.activeorDisableOn(item);
    } else {
      await this.activeorDisableOff(item);
    }
  };

  activeorDisableOff = async (item: FormuleConfig) => {
    const data_offline = await this.generalService.getDataFromLocalStorage(
      'formule-config'
    );
    let listOff: FormuleConfig[] = data_offline.filter(
      (a) => a.name !== item.name
    );
    listOff.push(item);
    localStorage.setItem('data_formule-config', JSON.stringify(listOff));

    this.notificationService.sendNotification(
      null,
      TypeMessage.Edit,
      ActionMessage.Success
    );
    this.getData();
  };

  activeorDisableOn = async (item: FormuleConfig) => {
    await this.service
      .saveOrUpdate(item)
      .then((node) => {
        this.notificationService.sendNotification(
          null,
          TypeMessage.Edit,
          ActionMessage.Success
        );
        this.getData();
      })
      .catch((err) => console.error(err));
  };

  makeSync = async () => {
    const data_offline: FormuleConfig[] =
      await this.generalService.getDataFromLocalStorage('formule-config');
    const status = JSON.parse(localStorage.getItem('statusNetwork'));
    if (status) {
      if (data_offline.length > 0) {
        await this.service
          .makeSync(data_offline)
          .then((res) => {
            this.notificationService.sendNotification(
              null,
              TypeMessage.Sync,
              ActionMessage.Success
            );
            this.getData();
            localStorage.removeItem('data_formule-config');
          })
          .catch((err) => {
            console.error(err);
            this.notificationService.sendNotification(
              null,
              TypeMessage.SyncError,
              ActionMessage.Error
            );
          });
      } else {
        this.notificationService.sendNotification(
          null,
          TypeMessage.SyncListEmpty,
          ActionMessage.Info
        );
      }
    }
  };
}
